import React from 'react';
import type { ISnapIcon } from '../icons-mapper';

export const ChevronDownSolid = (props: ISnapIcon) => {
  const { size, title, color = 'currentColor' } = props;
  return (
    <svg
      height={size}
      width={size}
      viewBox='0 0 20 20'
      fill={color}
      xmlns='http://www.w3.org/2000/svg'
    >
      <title>{title}</title>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M4.35092 6.3659C4.57568 6.14121 4.88048 6.01498 5.1983 6.01498C5.51611 6.01498 5.82091 6.14121 6.04567 6.3659L9.99251 10.3127L13.9393 6.3659C14.0499 6.25143 14.1822 6.16012 14.3284 6.09731C14.4746 6.03449 14.6319 6.00143 14.791 6.00005C14.9502 5.99866 15.108 6.02899 15.2553 6.08925C15.4026 6.14952 15.5364 6.23851 15.649 6.35105C15.7615 6.46358 15.8505 6.5974 15.9107 6.7447C15.971 6.892 16.0013 7.04982 16 7.20897C15.9986 7.36811 15.9655 7.52538 15.9027 7.67161C15.8399 7.81784 15.7486 7.95009 15.6341 8.06066L10.8399 12.8549C10.6151 13.0796 10.3103 13.2058 9.99251 13.2058C9.67469 13.2058 9.36989 13.0796 9.14513 12.8549L4.35092 8.06066C4.12623 7.8359 4 7.53109 4 7.21328C4 6.89547 4.12623 6.59067 4.35092 6.3659Z'
      />
    </svg>
  );
};
